import React, { useEffect, useRef, useState } from "react";
import MockTest from "./mocktest";
import MockTestAnalytics from "./mockTestAnalytics";
import MockTestSummary from "./mockTestSummary";
import { useStores } from "../../store";
import Loader from "../reusble_components/loader";
import { useLocation, useNavigate } from "react-router-dom";
import { MdArrowBackIos } from "react-icons/md";
import { setDataToLocalStorage } from "../../services/localStorage";
import Popup from "../reusble_components/popup";
import { loginWarningImage } from "../../helpers/constantVariables";
import ApplicationProgress from "./ApplicationProgress";
import { toJS } from "mobx";

export default function MockExamReport({ commingFrom = "student" }) {
  const contentRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const { MockStore, PopupStore, UserStore, CommonStore } = useStores();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  let Id = queryParams.get("id");
  MockStore.setId(Id);

  const getIdFromUrl = () => {
    // Get the current URL from the location
    if (!queryParams.get("id")) {
      const currentUrl = window.location.href; // Gets the full URL from the browser's address bar

      // Use the URL API to parse and extract the ID
      const url = new URL(currentUrl);
      const paths = url.pathname.split("/"); // Split the pathname by '/'
      Id = paths[paths.length - 1]; // Get the last part which is the ID
    }
  };
  useEffect(() => {
    getIdFromUrl();
    report();
  }, [window.location.href]);
  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/`;

    console.log(signupUrl);

    navigate(signupUrl);
  };
  useEffect(() => {
    if (!queryParams.get("id")) {
      // alert(1);
      getIdFromUrl();
    }
  }, []);
  const report = async () => {
    setLoader(true);
    const res = await MockStore.getReport(Id);
    if (res?.status === 200) {
      getApplicationStatus();
      setLoader(false);
    } else {
      setLoader(false);
    }
  };
  useEffect(() => {
    MockStore.report = null;
    report();
  }, []);

  const url = window.location.href;
  // Create a URL object and retrieve the 'mocktestId' from the query parameters
  const urlObj = new URL(url);
  const mocktestId = urlObj.searchParams.get("id");
  console.log("hello this is mocktestId ", mocktestId);
  const [lastInterview, setLastInterview] = useState(null);
  const [applicationId, setApplicationId] = useState(null);

  useEffect(() => {
    // UserStore.GetApplicationProgress("", "", mocktestId).then(() => {
    //   if (UserStore.ApplicationDetails) {
    //     console.log(
    //       "this is Application  Details",
    //       toJS(UserStore.ApplicationDetails)
    //     );
    //     if (
    //       UserStore.ApplicationDetails?.mockTestStatus === "pending" ||
    //       UserStore.ApplicationDetails?.mockTestStatus === "completed"
    //     ) {
    //       CommonStore.ApplicationProgress[1].hidden = false;
    //       if (UserStore.ApplicationDetails?.mockTestStatus === "pending") {
    //         CommonStore.ApplicationProgress[1].completed = false;
    //       } else {
    //         CommonStore.ApplicationProgress[1].completed = true;
    //       }
    //     } else {
    //       CommonStore.ApplicationProgress[1].hidden = true;
    //     }
    //     if (
    //       UserStore.ApplicationDetails?.technicalInterviewStatus ===
    //         "pending" ||
    //       UserStore.ApplicationDetails?.technicalInterviewStatus === "completed"
    //     ) {
    //       CommonStore.ApplicationProgress[2].hidden = false;
    //       if (
    //         UserStore.ApplicationDetails?.technicalInterviewStatus === "pending"
    //       ) {
    //         CommonStore.ApplicationProgress[2].completed = false;
    //       } else {
    //         CommonStore.ApplicationProgress[2].completed = true;
    //       }
    //     } else {
    //       CommonStore.ApplicationProgress[2].hidden = true;
    //     }
    //     if (
    //       UserStore.ApplicationDetails?.hrInterviewStatus === "pending" ||
    //       UserStore.ApplicationDetails?.hrInterviewStatus === "completed"
    //     ) {
    //       CommonStore.ApplicationProgress[3].hidden = false;
    //       if (UserStore.ApplicationDetails?.hrInterviewStatus === "pending") {
    //         CommonStore.ApplicationProgress[3].completed = false;
    //       } else {
    //         CommonStore.ApplicationProgress[3].completed = true;
    //       }
    //     } else {
    //       console.log(
    //         "UserStore.ApplicationDetails?.hrInterviewStatus",
    //         UserStore.ApplicationDetails?.hrInterviewStatus
    //       );
    //       CommonStore.ApplicationProgress[3].hidden = true;
    //     }
    //     if (UserStore.ApplicationDetails?.shortlisted === true) {
    //       CommonStore.ApplicationProgress[4].completed = true;
    //     } else {
    //       CommonStore.ApplicationProgress[4].completed = false;
    //     }
    //     if (UserStore.ApplicationDetails?.hired === true) {
    //       CommonStore.ApplicationProgress[5].hired = true;
    //     } else {
    //       CommonStore.ApplicationProgress[5].hired = false;
    //     }
    //     if (UserStore.ApplicationDetails?.rejected === true) {
    //       CommonStore.ApplicationProgress[4].rejected = true;
    //     } else {
    //       CommonStore.ApplicationProgress[4].rejected = false;
    //     }
    //     setApplicationId(UserStore.ApplicationDetails?.applicationId);
    //     const getNextStepId = (details) => {
    //       if (
    //         details.mockTestStatus !== "completed" &&
    //         details.mockTestStatus !== null
    //       )
    //         return details.mockTestId;
    //       if (
    //         (details.mockTestStatus === "completed" ||
    //           details.mockTestStatus === null) &&
    //         details.technicalInterviewStatus !== "completed" &&
    //         details.technicalInterviewStatus !== null
    //       )
    //         return details.technicalId;
    //       if (
    //         (details.technicalInterviewStatus === "completed" ||
    //           details.technicalInterviewStatus === null) &&
    //         details.hrInterviewStatus !== "completed" &&
    //         details.hrInterviewStatus !== null
    //       )
    //         return details.hrId;
    //       return null; // All interviews completed, or null treated as completed
    //     };
    //     const nextStepId = getNextStepId(UserStore.ApplicationDetails);
    //     setLastInterview(nextStepId);
    //   }
    // });
    getApplicationStatus();
  }, []);

  const getApplicationStatus = () => {
    UserStore.GetApplicationProgress("", "", mocktestId).then(() => {
      if (UserStore.ApplicationDetails) {
        console.log(
          "this is Application  Details",
          toJS(UserStore.ApplicationDetails)
        );
        if (
          UserStore.ApplicationDetails?.mockTestStatus === "pending" ||
          UserStore.ApplicationDetails?.mockTestStatus === "completed"
        ) {
          CommonStore.ApplicationProgress[1].hidden = false;
          if (UserStore.ApplicationDetails?.mockTestStatus === "pending") {
            CommonStore.ApplicationProgress[1].completed = false;
          } else {
            CommonStore.ApplicationProgress[1].completed = true;
          }
        } else {
          CommonStore.ApplicationProgress[1].hidden = true;
        }
        if (
          UserStore.ApplicationDetails?.technicalInterviewStatus ===
            "pending" ||
          UserStore.ApplicationDetails?.technicalInterviewStatus === "completed"
        ) {
          CommonStore.ApplicationProgress[2].hidden = false;
          if (
            UserStore.ApplicationDetails?.technicalInterviewStatus === "pending"
          ) {
            CommonStore.ApplicationProgress[2].completed = false;
          } else {
            CommonStore.ApplicationProgress[2].completed = true;
          }
        } else {
          CommonStore.ApplicationProgress[2].hidden = true;
        }
        if (
          UserStore.ApplicationDetails?.hrInterviewStatus === "pending" ||
          UserStore.ApplicationDetails?.hrInterviewStatus === "completed"
        ) {
          CommonStore.ApplicationProgress[3].hidden = false;
          if (UserStore.ApplicationDetails?.hrInterviewStatus === "pending") {
            CommonStore.ApplicationProgress[3].completed = false;
          } else {
            CommonStore.ApplicationProgress[3].completed = true;
          }
        } else {
          console.log(
            "UserStore.ApplicationDetails?.hrInterviewStatus",
            UserStore.ApplicationDetails?.hrInterviewStatus
          );
          CommonStore.ApplicationProgress[3].hidden = true;
        }
        if (UserStore.ApplicationDetails?.shortlisted === true) {
          CommonStore.ApplicationProgress[4].completed = true;
        } else {
          CommonStore.ApplicationProgress[4].completed = false;
        }
        if (UserStore.ApplicationDetails?.hired === true) {
          CommonStore.ApplicationProgress[5].hired = true;
        } else {
          CommonStore.ApplicationProgress[5].hired = false;
        }
        if (UserStore.ApplicationDetails?.rejected === true) {
          CommonStore.ApplicationProgress[4].rejected = true;
        } else {
          CommonStore.ApplicationProgress[4].rejected = false;
        }
        setApplicationId(UserStore.ApplicationDetails?.applicationId);
        const getNextStepId = (details) => {
          if (
            details.mockTestStatus !== "completed" &&
            details.mockTestStatus !== null
          )
            return details.mockTestId;
          if (
            (details.mockTestStatus === "completed" ||
              details.mockTestStatus === null) &&
            details.technicalInterviewStatus !== "completed" &&
            details.technicalInterviewStatus !== null
          )
            return details.technicalId;
          if (
            (details.technicalInterviewStatus === "completed" ||
              details.technicalInterviewStatus === null) &&
            details.hrInterviewStatus !== "completed" &&
            details.hrInterviewStatus !== null
          )
            return details.hrId;
          return null; // All interviews completed, or null treated as completed
        };
        const nextStepId = getNextStepId(UserStore.ApplicationDetails);
        setLastInterview(nextStepId);
      }
    });
  };

  // const handleDownload = () => {
  //     const content = contentRef.current;
  //     if (content) {
  //         html2pdf(content, {
  //             margin: 10,
  //             filename: 'mock_exam_report.pdf',
  //             image: { type: 'jpeg', quality: 1 },
  //             jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  //         });
  //     } else {
  //         alert("Content not found!");
  //     }
  // };

  return (
    <>
      {MockStore.report?.mockTestName ? (
        <div className="">
          {UserStore.ApplicationDetails && commingFrom === "student" && (
            <div className="w-full ml-[2%]  ml-0 bg-white md:top-0 lg:top-0 py-2 left-10 top-0 z-50 shadow-xl justify-between items-center rounded-lg  md:px-[2%] lg:px-[2%] px-10 flex p-0">
              <div className="w-fit -ml-6 md:overflow-x-hidden lg:overflow-x-hidden md:overflow-x-hidden lg:overflow-x-hidden  overflow-x-scroll no-scrollbar ">
                <ApplicationProgress className="w-fit" />
              </div>
              {lastInterview ? (
                <>
                  <button
                    onClick={() => {
                      console.log(
                        "this is lastInterview and applicationid",
                        lastInterview,
                        applicationId
                      );
                      if (lastInterview) {
                        navigate(
                          `/interview-invitation?meetingid=${lastInterview}&applicationId=${applicationId}`
                        );
                      }
                    }}
                    className="bg-primary text-white h-fit md:text-base lg:text-base text-lg font-semibold w-fit px-5 py-1 md:hidden lg:hidden rounded-lg"
                  >
                    Continue
                  </button>
                  <button
                    onClick={() => {
                      console.log(
                        "this is lastInterview and applicationid",
                        lastInterview,
                        applicationId
                      );
                      if (lastInterview) {
                        navigate(
                          `/interview-invitation?meetingid=${lastInterview}&applicationId=${applicationId}`
                        );
                      }
                    }}
                    className="bg-primary text-white h-fit md:text-base lg:text-base text-xs font-semibold w-fit md:px-7 lg:px-7 py-3 md:flex lg:flex hidden rounded-xl mr-4"
                  >
                    Continue with Next step
                  </button>
                </>
              ) : (
                <>
                  <p className="bg-green-500 text-white h-fit md:text-xs lg:text-sm text-xs font-semibold w-fit md:px-7 lg:px-7 py-3 md:flex lg:flex hidden rounded-xl">
                    {" "}
                    Application Submitted Succesfully
                  </p>
                  <p className="bg-green-500 text-white h-fit md:text-base lg:text-base text-[10px] truncate font-semibold w-fit px-5 py-1 md:hidden lg:hidden rounded-lg">
                    {" "}
                    Submitted Succesfully
                  </p>
                </>
              )}
            </div>
          )}
          <div className="my-10 px-[5%]" ref={contentRef}>
            {PopupStore.loginWarning && (
              <Popup
                popUpInitialValue={PopupStore.loginWarning}
                handlePopup={() => {
                  PopupStore.setLoginWarning(false);
                }}
                image={loginWarningImage}
                content="Please signup to start Mock Test"
                buttontext="Signup now"
                onClick={() => {
                  redirectToSignupPageWithCurrentUrl();
                  PopupStore.setLoginWarning(false);
                }}
              />
            )}
            <Loader loader={loader} />
            {/* {queryParams.get("id") && (
        <div className="flex  justify-start max-sm:justify-center">
          <img className="mb-10 w-[20%] max-sm:w-[50%]" src={logo} alt="logo" />
        </div>
      )} */}

            <div>
              {queryParams.get("id") && (
                <span
                  className="font-semibold text-primary text-xl cursor-pointer flex items-center md:mt-10 lg:m mt-24 gap-2"
                  onClick={() => {
                    // MockStore.report = null;
                    navigate("/");
                  }}
                >
                  <MdArrowBackIos /> Back
                </span>
              )}
              <MockTest branch={MockStore.report?.mockTestName} />

              <MockTestAnalytics />
              <MockTestSummary />
            </div>
            {/* <div className="w-[100%] flex justify-end items-center mt-5">
                <button className="bg-[#ff6b00] text-white px-4 py-2 rounded-lg text-lg" onClick={handleDownload}>Download</button>
            </div> */}
          </div>
        </div>
      ) : (
        <Loader loader={loader} text="Loading..." />
      )}
    </>
  );
}
